import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { JobsService } from 'src/app/service/jobs/jobs.service';

@Component({
  selector: 'app-edit-customer',
  templateUrl: './edit-customer.component.html',
  styleUrls: ['./edit-customer.component.scss'],
})
export class EditCustomerComponent implements OnInit {
  id;
  arCustomerDetail;
  arCustomerDetailForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private jobsService: JobsService,
    private router: Router,
    private formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.getCustomerDetails();
    this.initializeForms();
  }

  getCustomerDetails() {
    this.jobsService.getARCustomerById(this.id).subscribe(
      res => this.onARCustomerSuccess(res),
      error => this.onARCustomerError(error),
    );
  }

  //On success of arcustomer api call
  onARCustomerSuccess(result) {
    if (!result?.response) return;
    this.arCustomerDetail = result.response;
    this.initializeForms(result.response);
  }

  //On error of arcustomer api call
  onARCustomerError(error) {
    console.error(error);
  }

  submitCustomerDetails(form) {
    if (form.invalid) return;

    this.jobsService.updateARCustomerById(form.value).subscribe(
      res => this.onARCustomerUpdateSuccess(res),
      error => this.onARCustomerUpdateError(error),
    );
  }

  //On success of arcustomer api call
  onARCustomerUpdateSuccess(result) {
    if (!result?.batchResponse?.success?.length) return;

    this.router.navigate(['customers']);
  }

  //On error of arcustomer api call
  onARCustomerUpdateError(error) {
    console.error(error);
  }

  initializeForms(data: any = null) {
    const defaultContact = { billingNote: '', contactName: '', phoneNumber: '', billingEmail: '', contactEmail: '' };
    const contacts = data?.billing_contacts?.contacts || [defaultContact];

    this.arCustomerDetailForm = this.formBuilder.group({
      id: data?.id ?? '',
      name: data?.name ?? '',
      customer_id: data?.customer_id ?? '',
      address: data?.address ?? '',
      city: data?.city ?? '',
      state: data?.state ?? '',
      zip: data?.zip ?? '',
      billingDetailsArray: this.formBuilder.array(contacts.map(item => this.createDynamicGroup(item))),
    });
  }

  createDynamicGroup(item): FormGroup {
    return this.formBuilder.group({
      billingNote: [item?.billingNote || ''],
      contactName: [item?.contactName || ''],
      phoneNumber: [item?.phoneNumber || ''],
      billingEmail: [item?.billingEmail || ''],
      contactEmail: [item?.contactEmail || ''],
    });
  }

  get billingDetailsArray() {
    return this.arCustomerDetailForm.get('billingDetailsArray') as FormArray;
  }

  addRow() {
    const newDynamicGroup = this.formBuilder.group({
      contactName: '',
      contactEmail: '',
      phoneNumber: '',
      billingEmail: '',
      billingNote: '',
    });
    (this.arCustomerDetailForm.get('billingDetailsArray') as FormArray).push(newDynamicGroup);
  }
  deleteRow(index: number) {
    (this.arCustomerDetailForm.get('billingDetailsArray') as FormArray).removeAt(index);
  }
}
